import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _styled from "@emotion/styled-base";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import isPropValid from '@emotion/is-prop-valid';
import withProps from 'recompose/withProps';
import { componentStyleReset, getNormalizedValue, pxToEm } from "../styles";
import { themed, mapComponentThemes } from "../themes";
import { rtlTextAlign } from "../utils";
import { ignoreSsrWarning } from "../utils/emotion";
import Checkbox from "../Checkbox";
import OverflowContainer from "../OverflowContainer/OverflowContainer";
import { tableCellTheme, tableTheme, tableHeaderCellTheme, tableHeaderTheme, tableRowTheme, tableSortableHeaderCellTheme, tableTitleTheme } from "./themes";
import TableHeaderCell from "./TableHeaderCell";
import { SORT } from "./constants";
var REGEX_IS_EM_VALUE = /\d+em$/;

var tableCellStyles = function tableCellStyles(_ref) {
  var _ref2, _ref3;

  var density = _ref.density,
      highContrast = _ref.highContrast,
      noPadding = _ref.noPadding,
      textAlign = _ref.textAlign,
      baseTheme = _ref.theme;
  var theme = tableCellTheme(baseTheme);
  var fontSize = theme.TableCell_fontSize;
  var rtl = theme.direction === 'rtl';
  var borderProperty = rtl ? 'borderRight' : 'borderLeft';
  var borderVertical = highContrast ? theme.TableCell_borderVertical_highContrast : theme.TableCell_borderVertical;
  var paddingHorizontal = getNormalizedValue(theme.TableCell_paddingHorizontal, fontSize);
  var paddingVertical = getNormalizedValue(density === 'spacious' ? theme.TableCell_paddingVertical_spacious : theme.TableCell_paddingVertical, fontSize);
  return _ref3 = {
    fontSize: fontSize,
    fontWeight: 'inherit',
    padding: noPadding ? 0 : paddingVertical + " " + paddingHorizontal,
    textAlign: rtlTextAlign(textAlign || 'start', theme.direction),
    verticalAlign: theme.TableCell_verticalAlign
  }, _ref3['&:not(:first-child)' + ignoreSsrWarning] = (_ref2 = {}, _ref2[borderProperty] = borderVertical, _ref2), _ref3;
};

export var TableOverflowContainer = themed(OverflowContainer)(function (_ref4) {
  var baseTheme = _ref4.theme;
  return mapComponentThemes({
    name: 'Table',
    theme: tableTheme(baseTheme)
  }, {
    name: 'OverflowContainer',
    theme: {}
  }, baseTheme);
});
export var TableRoot =
/*#__PURE__*/
_styled('table', {
  target: "e1tsrciw0"
})(function (_ref5) {
  var theme = _ref5.theme;
  return _objectSpread({}, componentStyleReset(theme), {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    width: '100%'
  });
});
export var TableBody =
/*#__PURE__*/
_styled('tbody', {
  target: "e1tsrciw1"
})();
export var TableCellRoot =
/*#__PURE__*/
_styled('td', {
  target: "e1tsrciw2"
})(tableCellStyles);
export var TableHeaderRoot =
/*#__PURE__*/
_styled('thead', {
  target: "e1tsrciw3"
})(function (_ref6) {
  var hide = _ref6.hide,
      highContrast = _ref6.highContrast,
      baseTheme = _ref6.theme;
  var theme = tableHeaderTheme(baseTheme);
  return hide ? {
    border: "0",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  } : {
    borderBottom: highContrast ? theme.TableHeader_borderBottom_highContrast : theme.TableHeader_borderBottom,
    borderTop: highContrast ? theme.TableHeader_borderTop_highContrast : theme.TableHeader_borderTop
  };
});
export var TableHeaderCellRoot =
/*#__PURE__*/
_styled('th', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'width' && isPropValid(prop);
  },
  target: "e1tsrciw4"
})(function (_ref7) {
  var baseTheme = _ref7.theme,
      props = _objectWithoutPropertiesLoose(_ref7, ["theme"]);

  var theme = mapComponentThemes({
    name: 'TableHeaderCell',
    theme: tableHeaderCellTheme(baseTheme)
  }, {
    name: 'TableCell',
    theme: {}
  }, baseTheme, ['TableHeaderCell_borderVertical', 'TableHeaderCell_fontSize', 'TableHeaderCell_paddingHorizontal', 'TableHeaderCell_paddingVertical', 'TableHeaderCell_verticalAlign']);
  return tableCellStyles(_objectSpread({
    theme: theme
  }, props));
}, function (_ref8) {
  var _before, _ref9, _ref10;

  var highContrast = _ref8.highContrast,
      maxWidth = _ref8.maxWidth,
      minWidth = _ref8.minWidth,
      baseTheme = _ref8.theme,
      width = _ref8.width;
  var theme = tableHeaderCellTheme(baseTheme);
  var fontSize = theme.TableHeaderCell_fontSize;
  var rtl = theme.direction === 'rtl';
  var borderProperty = rtl ? 'borderRight' : 'borderLeft';
  var borderVertical = highContrast ? theme.TableHeaderCell_borderVertical_highContrast : theme.TableHeaderCell_borderVertical;
  var positionProperty = rtl ? 'right' : 'left';

  var getWidth = function getWidth(value, fontSize) {
    return REGEX_IS_EM_VALUE.test(value) ? getNormalizedValue(value, fontSize) : value;
  };

  return _ref10 = {
    fontWeight: theme.TableHeaderCell_fontWeight,
    maxWidth: getWidth(maxWidth, fontSize),
    minWidth: getWidth(minWidth, fontSize),
    position: 'relative',
    width: getWidth(width, fontSize),
    zIndex: 1
  }, _ref10['&:not(:first-child)' + ignoreSsrWarning] = (_ref9 = {}, _ref9[borderProperty] = 0, _ref9['&::before'] = (_before = {}, _before[borderProperty] = borderVertical, _before.bottom = 0, _before.content = '""', _before[positionProperty] = 0, _before.position = 'absolute', _before.top = 0, _before.width = 0, _before.zIndex = -1, _before), _ref9), _ref10;
});
export var TableRowRoot =
/*#__PURE__*/
_styled('tr', {
  target: "e1tsrciw5"
})(function (_ref11) {
  var _objectSpread2, _ref12;

  var highContrast = _ref11.highContrast,
      isSelected = _ref11.isSelected,
      baseTheme = _ref11.theme,
      striped = _ref11.striped;
  var theme = tableRowTheme(baseTheme);
  return _objectSpread({
    backgroundColor: function () {
      if (isSelected) {
        if (highContrast) {
          return theme.TableRow_backgroundColor_highContrast_selected;
        }

        return theme.TableRow_backgroundColor_selected;
      }
    }()
  }, highContrast ? {
    borderBottom: theme.TableRow_borderHorizontal_highContrast
  } : {
    '&:not(:last-child)': {
      borderBottom: theme.TableRow_borderHorizontal
    }
  }, (_objectSpread2 = {
    '*:not(thead) > &:hover': {
      backgroundColor: function () {
        if (isSelected) {
          if (highContrast) {
            return theme.TableRow_backgroundColor_highContrast_selectedHover;
          }

          return theme.TableRow_backgroundColor_selectedHover;
        }

        return theme.TableRow_backgroundColor_hover;
      }()
    }
  }, _objectSpread2['&:nth-child(even):not(:hover)' + ignoreSsrWarning] = {
    backgroundColor: !isSelected && striped ? theme.TableRow_backgroundColor_striped : null
  }, _objectSpread2), isSelected ? (_ref12 = {}, _ref12['& > td:first-child, & > th:first-child' + ignoreSsrWarning] = {
    position: 'relative',
    '&::before': {
      backgroundColor: theme.color_theme_60,
      bottom: 0,
      content: '""',
      left: theme.direction !== 'rtl' ? 0 : null,
      right: theme.direction === 'rtl' ? 0 : null,
      position: 'absolute',
      top: 0,
      width: '4px'
    }
  }, _ref12) : undefined);
});
export var PaddedCheckbox = withProps({
  hideLabel: true
})(
/*#__PURE__*/
_styled(Checkbox, {
  target: "e1tsrciw6"
})(function (_ref13) {
  var density = _ref13.density,
      isHeader = _ref13.isHeader,
      baseTheme = _ref13.theme;
  var theme = isHeader ? tableHeaderCellTheme(baseTheme) : tableCellTheme(baseTheme);
  var themePrefix = isHeader ? 'TableHeaderCell' : 'TableCell';
  var paddingVertical = density === 'spacious' ? theme[themePrefix + "_paddingVertical_spacious"] : theme[themePrefix + "_paddingVertical"];
  return {
    padding: paddingVertical + " " + theme[themePrefix + "_paddingHorizontal"]
  };
}));

var tableSortableHeaderCellFocusStyles = function tableSortableHeaderCellFocusStyles(theme) {
  return {
    color: theme.TableSortableHeaderCell_color_focus,
    outline: theme.TableSortableHeaderCell_border_focus,
    outlineOffset: "-" + theme.TableSortableHeaderCell_border_focus.split(' ')[0]
  };
};

export var TableSortableHeaderCellRoot = withProps({
  noPadding: true
})(
/*#__PURE__*/
_styled(TableHeaderCell, {
  target: "e1tsrciw7"
})(function (_ref14) {
  var baseTheme = _ref14.theme;
  var theme = tableSortableHeaderCellTheme(baseTheme);
  return {
    overflow: 'hidden',
    // [1]
    '&:hover': {
      color: theme.TableSortableHeaderCell_color_hover
    },
    '&:focus-within': tableSortableHeaderCellFocusStyles(theme)
  };
}));
export var TableSortableHeaderCellButton = withProps({
  as: 'button'
})(
/*#__PURE__*/
_styled(TableHeaderCell, {
  target: "e1tsrciw8"
})(function (_ref15) {
  var baseTheme = _ref15.theme;
  var theme = tableSortableHeaderCellTheme(baseTheme);
  return {
    background: 'none',
    border: 0,
    color: 'inherit',
    cursor: 'pointer',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: '100%',
    '&:focus': tableSortableHeaderCellFocusStyles(theme),
    '*:focus-within > &:focus': {
      outline: 0
    },
    '&::-moz-focus-inner': {
      border: 0
    },
    // [1]
    '&::after': {
      bottom: '100%',
      content: '""',
      height: '10em',
      left: 0,
      position: 'absolute',
      right: 0
    }
  };
}));
export var TableSortableHeaderCellContent =
/*#__PURE__*/
_styled('span', {
  target: "e1tsrciw9"
})({
  name: "156zkco",
  styles: "position:relative;white-space:normal;"
});
export var TableSortableHeaderCellIconHolder =
/*#__PURE__*/
_styled('span', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'direction' && isPropValid(prop);
  },
  target: "e1tsrciw10"
})(function (_ref16) {
  var _ref17;

  var isSorted = _ref16.isSorted,
      direction = _ref16.direction,
      baseTheme = _ref16.theme;
  var theme = tableSortableHeaderCellTheme(baseTheme);
  var iconAdjustment = pxToEm(2);
  var marginProperty = theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _ref17 = {
    color: theme.icon_color,
    display: 'inline-block',
    height: theme.TableSortableHeaderCellIcon_size
  }, _ref17[marginProperty] = parseFloat(theme.space_inline_xxs) + parseFloat(iconAdjustment) + "em", _ref17.opacity = isSorted ? null : 0, _ref17.position = 'relative', _ref17.top = direction === SORT.ascending ? 2 : 1, _ref17.width = theme.TableSortableHeaderCellIcon_size, _ref17['& > [role="img"]'] = {
    margin: "-" + iconAdjustment
  }, _ref17['*:hover > button > &, button:focus > &'] = {
    color: 'inherit'
  }, _ref17;
});
export var TableTitleRoot =
/*#__PURE__*/
_styled('caption', {
  target: "e1tsrciw11"
})(function (_ref18) {
  var hide = _ref18.hide,
      baseTheme = _ref18.theme;
  var theme = tableTitleTheme(baseTheme);
  return _objectSpread({
    marginBottom: theme.TableTitle_marginBottom
  }, hide ? {
    border: "0",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  } : undefined);
}); // [1] Extends the clickable area of the Button to fill the entire cell